var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMascotte7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_263_223",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#63D5B0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_263_223)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M-1.67507 192.225C81.1081 187.996 107.535 245.143 238.128 221.4C342.261 202.47 387.091 273.147 400.059 317.055C406.248 338.034 407.82 420.029 350.677 421.2C156.753 425.233 1.37035 637.751 -92.1209 451.904C-130.041 376.511 -189.607 201.852 -1.67507 192.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M461.325 -201.775C544.108 -206.004 570.535 -148.857 701.128 -172.6C805.261 -191.53 850.091 -120.853 863.059 -76.9446C869.248 -55.9661 870.82 26.0293 813.677 27.2002C619.753 31.2333 464.37 243.751 370.879 57.9037C332.959 -17.4891 273.393 -192.148 461.325 -201.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 20,
    width: 267,
    height: 303,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 20,
    width: 267,
    height: 303,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_263_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.13 342.075C246.97 366.145 268.4 393.077 295.05 393.257C321.711 393.438 343.503 366.808 343.663 342.727C343.824 318.657 322.303 306.25 295.643 306.069C268.982 305.889 247.291 317.994 247.12 342.065L247.13 342.075Z",
    fill: "url(#paint0_linear_263_223)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.658 303.549L227.649 303.555C222.985 306.652 221.714 312.944 224.811 317.608L244.081 346.635C247.178 351.3 253.47 352.571 258.135 349.474L258.143 349.468C262.808 346.371 264.079 340.079 260.982 335.415L241.711 306.388C238.614 301.723 232.322 300.452 227.658 303.549Z",
    fill: "url(#paint1_linear_263_223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.013 349.466L328.022 349.471C332.686 352.568 338.978 351.297 342.075 346.632L361.346 317.606C364.443 312.941 363.172 306.649 358.507 303.552L358.499 303.547C353.834 300.45 347.542 301.721 344.445 306.385L325.174 335.412C322.077 340.077 323.348 346.369 328.013 349.466Z",
    fill: "url(#paint2_linear_263_223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.499 246.385L249.408 236.588C244.49 233.587 238.306 233.567 233.368 236.538C225.026 241.537 218.753 249.356 215.681 258.581C210.582 273.868 217.408 290.581 231.742 297.929L247.682 306.1L265.489 246.385H265.499Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.487 255.449L249.107 247.309C245.011 244.819 239.872 244.799 235.766 247.269C228.84 251.424 223.621 257.929 221.071 265.588C216.835 278.295 222.507 292.188 234.431 298.301L247.681 305.096L262.487 255.449Z",
    fill: "url(#paint3_linear_263_223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.409 246.385L337.5 236.588C342.418 233.587 348.601 233.567 353.54 236.538C361.871 241.537 368.145 249.356 371.217 258.571C376.316 273.858 369.49 290.571 355.156 297.919L339.216 306.089L321.409 246.375V246.385Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.42 255.449L337.8 247.309C341.896 244.819 347.035 244.799 351.14 247.269C358.066 251.424 363.286 257.929 365.836 265.588C370.072 278.295 364.4 292.188 352.475 298.301L339.226 305.096L324.42 255.449Z",
    fill: "url(#paint4_linear_263_223)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_263_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.156 293.834C347.156 323.495 323.115 336.795 293.454 336.795C263.792 336.795 239.752 323.495 239.752 293.834C239.752 264.172 272.856 232.322 293.454 232.322C314.051 232.322 347.156 264.172 347.156 293.834Z",
    fill: "url(#paint5_linear_263_223)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_263_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.021 236.147C286.758 239.78 286.839 250.36 286.839 250.36C286.949 250.721 287.461 250.601 287.632 250.491C288.364 250.019 290.051 247.961 290.051 247.961C290.261 247.66 290.713 247.73 290.834 248.072C290.834 248.072 291.948 251.906 292.199 255.349C292.219 255.57 292.881 255.449 293.052 255.329C294.648 254.174 295.993 247.841 295.993 247.841C296.093 247.489 296.535 247.399 296.766 247.67C296.766 247.67 298.573 248.493 299.516 250.962C299.587 251.153 300.149 250.902 300.299 250.762C303.301 248.011 305.127 237.592 302.879 234.35C299.687 229.743 277.624 232.764 282.021 236.137V236.147Z",
    fill: "#8058EA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.344 282.511C269.614 277.241 278.146 277.241 283.415 282.511",
    stroke: "#474193",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.487 282.511C307.757 277.241 316.289 277.241 321.559 282.511",
    stroke: "#474193",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.474 308.288L310.377 308.037C317.815 305.999 324.45 301.733 329.389 295.811C330.523 294.456 332.691 294.857 333.263 296.524C335.14 301.974 336.546 310.647 330.031 315.405C320.164 322.622 311.753 315.535 308.4 312.002C307.226 310.767 307.818 308.729 309.464 308.278L309.474 308.288Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_263_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.127 313.578L242.332 311.319C243.245 309.613 245.494 308.951 247.059 310.095C247.17 310.175 250.312 316.007 252.61 317.754C255.14 319.671 260.149 319.902 264.555 315.676C270.397 310.075 271.1 301.262 275.095 297.738C282.111 291.545 290.573 292.569 296.435 297.658C302.297 302.747 303.502 312.183 299.346 318.798C295.211 325.392 280.586 333.222 273.128 335.35C263.973 337.96 254.849 333.754 250.844 330.682C244.44 325.794 240.194 318.266 240.194 318.266C238.407 316.519 239.621 314.642 241.137 313.578H241.127Z",
    fill: "url(#paint6_linear_263_223)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_263_223",
    x: 239.12,
    y: 301.067,
    width: 112.544,
    height: 103.191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_223"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_223",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_263_223",
    x: 231.752,
    y: 227.322,
    width: 123.404,
    height: 120.473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_223"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_223",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_263_223",
    x: 279.443,
    y: 231,
    width: 26.4385,
    height: 27.4722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_223"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_223",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_263_223",
    x: 231.305,
    y: 288.46,
    width: 78.5,
    height: 58.7075,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_223"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_223",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_263_223",
    x1: 295.401,
    y1: 306.069,
    x2: 295.4,
    y2: 393.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_263_223",
    x1: 256.561,
    y1: 302.451,
    x2: 271.89,
    y2: 271.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_263_223",
    x1: 325.282,
    y1: 294.492,
    x2: 309.958,
    y2: 263.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_263_223",
    x1: 262.487,
    y1: 275.264,
    x2: 219.676,
    y2: 275.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_263_223",
    x1: 324.42,
    y1: 275.264,
    x2: 367.231,
    y2: 275.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_263_223",
    x1: 293.454,
    y1: 336.795,
    x2: 293.454,
    y2: 232.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_263_223",
    x1: 297.042,
    y1: 298.031,
    x2: 248.602,
    y2: 331.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotte7);
export default __webpack_public_path__ + "static/media/mascotte7.1a4432aa7b66d500eb7e6a4a78171fa8.svg";
export { ForwardRef as ReactComponent };